import jwt_decode from "jwt-decode";

//true si el token JWT existe, se puede leer y no ha caducado
export const tokenVigente = (token) => {
    if (!token) {
        return false;
    }
    try {
        const { exp } = jwt_decode(token);
        return Boolean(exp) && exp * 1000 > Date.now();
    } catch (e) {
        return false;
    }
}
